import Swal from 'sweetalert2'

import { lang } from '../../assets/lang'
import { sequenceSingleHtml } from './sequenceSingleHtml'
import { sweetAlertCommonParams } from '../../functions/utils'

// eslint-disable-next-line
export const sequenceSingleModal = async (oldData, node) => {
  const commonParams = sweetAlertCommonParams(node)
  
  return await Swal.fire({
    ...commonParams,
    title: lang.sequence_single_modal_title,
    html: sequenceSingleHtml,

    willOpen: () => {
      $('.select2').select2({ 
        width: '100%',
        dropdownParent: $('#swal2-content')
      })

      $('.button-onDemand-field').hide()

      if (oldData.isPromotionalChecked) {
        $('#sequence-single-promotional').prop('checked', oldData.isPromotionalChecked)
        $('#sequence-single-hours').val(oldData.promotional || '').trigger('change')
        $('#sequence-single-hours-group').show()
      } else if (oldData.isNonPromotionalChecked) {
        $('#sequence-single-non-promotional').prop('checked', oldData.isNonPromotionalChecked)
        $('#sequence-single-days').val(oldData.nonPromotional || '').trigger('change')
        $('#sequence-single-days-group').show()
      }
      
      $(document).on('change', '#sequence-single-promotional, #sequence-single-non-promotional', function() {
          const isPromotionalChecked = $('#sequence-single-promotional').prop('checked')
          const isNonPromotionalChecked = $('#sequence-single-non-promotional').prop('checked')
    
          if (isPromotionalChecked) {
            $('#sequence-single-days-group').hide()
            $('#sequence-single-hours-group').show()
          } else if (isNonPromotionalChecked) {
            $('#sequence-single-hours-group').hide()
            $('#sequence-single-days-group').show()
          }
      })
    },

    preConfirm: () => {
      const isPromotionalChecked = $('#sequence-single-promotional').prop('checked')
      const isNonPromotionalChecked = $('#sequence-single-non-promotional').prop('checked')

      let promotional = $('#sequence-single-hours').val()
      let promotionalText = $('#sequence-single-hours option:selected').text()

      let nonPromotional = $('#sequence-single-days').val()
      let nonPromotionalText = $('#sequence-single-days option:selected').text()

      if (! isPromotionalChecked && ! isNonPromotionalChecked) {
        Swal.showValidationMessage(lang.sequence_single_modal_msg_promotional_or_non_promotional)
      }

      if (isPromotionalChecked && ! promotional) {
        Swal.showValidationMessage(lang.sequence_single_modal_msg_promotional)
      }

      if (isNonPromotionalChecked && ! nonPromotional) {
        Swal.showValidationMessage(lang.sequence_single_modal_msg_non_promotional)
      }

      if (isPromotionalChecked && promotional) {
        nonPromotional = ''
        nonPromotionalText = ''
      } else if (isNonPromotionalChecked && nonPromotional) {
        promotional = ''
        promotionalText = ''
      }
  
      return {
        isPromotionalChecked,
        isNonPromotionalChecked,

        promotional,
        promotionalText,

        nonPromotional,
        nonPromotionalText,
      }
    },    
  })
}